import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/app';
import { IUserState } from './modules/user';
import { ITagsViewState } from './modules/tags-view';
import { IPermissionState } from './modules/permission';
import { IFileAnalysisState } from './modules/file_analysis';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  user: IUserState;
  tagsView: ITagsViewState;
  permission: IPermissionState;
  fileAnalysis: IFileAnalysisState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
